export default __webpack_public_path__ + "static/media/ico-home-ac.0115a6e6.svg";